import { render, staticRenderFns } from "./CustomPaymentTabV1.vue?vue&type=template&id=1d1c0e70&scoped=true&"
import script from "./CustomPaymentTabV1.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentTabV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c0e70",
  null
  
)

export default component.exports